import { ButtonIcon } from '@vds/button-icons'
import { ListItem, UnorderedList } from '@vds/lists'
import { TileContainer } from '@vds/tiles'
import { Body, Micro, Title } from '@vds/typography'
import React, { useEffect, useState } from 'react'
import { Icon } from '@vds/icons'
import './CourseDetailsSection/CourseDetailsSection.scss'
import { useSelector } from 'react-redux';
import { decodeHTML } from '../../utility/common'
import { getImageToBeRendered, navigateUsingLanguage } from '../../utility/utils'

const InstructorCard = ({ instructor, forEvent }) => {
  const newtag =  useSelector((state)=>state.Aem.instructorData?.newtaglabel);
  const bioItem1 =  instructor?.bioitem1 ? instructor?.bioitem1 : instructor?.bio1;
  const bioItem2 =  instructor?.bioitem2 ? instructor?.bioitem2 : instructor?.bio2;
  const bioItem3 =  instructor?.bioitem3 ? instructor?.bioitem3 : instructor?.bio3;
 const [imageUrl,setImageUrl] = useState(instructor?.profileimg)
const [profileImg, setProfileImg] = useState(null);

React.useEffect(() => {
  let cancelled = false;
  const loadProfileImg = async () => {
    const url = await getImageToBeRendered('','','instructorProfile','',instructor?.profileimg,'','','detInsCard');
    if (!cancelled) setProfileImg(url);
  };
  loadProfileImg();
  return () => { cancelled = true; };
}, [instructor?.profileimg]);


  return (
    <div className='instructor_card'>
        <TileContainer
          tabIndex={-1}
          padding='24px'
          width='100%'
          height='100%'
          backgroundColor="#fff"
          ariaLabel={`${instructor?.firstName ?  instructor?.firstName : instructor?.fname} ${instructor?.lastName ? instructor?.lastName : instructor?.lname} Instructor Card`}
          onClick={instructor?.instructorID ? "" : () => navigateUsingLanguage(`/instructor-details/${instructor?.instructorID}`)}
        >
          <div className='n-displayFlex width-100'>
            <img className='instructor_card_img' src={profileImg ? profileImg : ""} alt="Instructor" />
            <div className='ml-6X n-displayFlex sm-n-flexDirectionCol n-justifyContentSpaceBetween width-100'>
              <div>
                <div className='n-displayFlex'>
                  <div className='flag'><Body size='small' bold>{instructor?.designation ? instructor?.designation : instructor?.tag}</Body></div>
                  {instructor?.new === "true" && (!(instructor?.newTagDate > Date.now()) && (Math.abs(instructor?.newTagDate - Date.now())) <= (45 * 24 * 60 * 60 * 1000)) &&
                    (<div className='ml-2X flag flag'><Body size='small' bold>{newtag}</Body></div>)
                  }
                </div>
                <div className='n-displayFlex sm-n-flexDirectionCol mt-3X mb-1X'>
                  <div className='mr-1X sm-mb-1X sm-mr-0X'><Title size='medium' bold>{instructor?.firstName ? instructor?.firstName : instructor?.fname}</Title></div>
                  <div><Title size='medium' bold>{instructor?.lastName ? instructor?.lastName : instructor?.lname}</Title></div>
                </div>
                <div className='n-displayFlex sm-n-flexDirectionCol mb-3X'>
                  <div className='mr-1X sm-mb-1X sm-mr-0X'><Micro bold color='#6F7171'>{instructor?.jobTitle}</Micro></div>
                  <div className='mr-1X sm-mb-1X sm-mr-0X'><Micro color='#6F7171'>{instructor?.companyname ? instructor?.companyname : instructor?.cmpnyName}</Micro></div>
                </div>
                <div className='sm-hide'>
                  <UnorderedList>
                    {bioItem1 && (
                      <ListItem
                        size="micro"
                        spacing="compact"
                      >
                        {decodeHTML(bioItem1)}
                      </ListItem>
                    )}
                    {bioItem2 && (
                      <ListItem
                        size="micro"
                        spacing="compact"
                      >
                        {decodeHTML(bioItem2)}
                      </ListItem>
                    )}
                    {bioItem3 && (
                      <ListItem
                        size="micro"
                        spacing="compact"
                      >
                        {decodeHTML(bioItem3)}
                      </ListItem>
                    )}
                  </UnorderedList>
                </div>
                {bioItem1 && <div className='hide sm-show'><Micro>{decodeHTML(bioItem1)}</Micro></div>}
              </div>
              {instructor?.instructorID && <div className='sm-mt-3X'>
                <ButtonIcon
                  kind="lowContrast"
                  ariaLabel="Visit Instructor page link"
                  size="small"
                  onClick={(e) => {
                    if (e.detail === 0) return; // Prevent programmatic focus-triggered clicks
                    navigateUsingLanguage(`/instructor-details/${instructor?.instructorID}`);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      navigateUsingLanguage(`/instructor-details/${instructor?.instructorID}`);
                    }
                  }}
                  renderIcon={(props) => <Icon name="right-arrow" {...props} />}
                />
              </div>}
            </div>
          </div>
        </TileContainer>
      </div>
  )
}

export default InstructorCard